import { render, staticRenderFns } from "./StepTeamComposition.vue?vue&type=template&id=0a0819df&scoped=true&"
import script from "./StepTeamComposition.vue?vue&type=script&lang=js&"
export * from "./StepTeamComposition.vue?vue&type=script&lang=js&"
import style0 from "./StepTeamComposition.vue?vue&type=style&index=0&id=0a0819df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0819df",
  null
  
)

export default component.exports